import { FilterProps, FilterValues, KmsTypeFilterDropdown } from "@kaltura/mediaspace-shared-types";
import { IconButton, Menu, menuClasses, Tooltip } from "@kaltura/ds-react-components";
import { Settings24Icon } from "@kaltura/ds-react-icons";
import { translate } from "@kaltura/mediaspace-shared-utils";
import { MouseEvent, useState, useEffect } from "react";
import styled from "@emotion/styled";
import FieldsSelector from "./../fields-selector/FieldsSelector";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";

/**
 * props for the FilterMenu component
 */
export type FilterMenuProps = FilterProps<KmsTypeFilterDropdown>;

const StyledMenu = styled(Menu)({
    [`& .${menuClasses.paper}`]: {
        width: 205,
    },
});

const StyledIconButton = styled(IconButton)({
    minWidth: "auto",
    padding: 0,
    [`&:hover`]: {
        backgroundColor: "transparent",
    },
});

/**
 * menu shown inside keyword search box:
 * shows button and controls popup
 * converts given "dropdown filters" data to "radio filters" data
 */
export function FilterMenu(props: FilterMenuProps) {
    const sendButtonAnalytics = useButtonAnalytics();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

    const open = Boolean(anchorEl);

    // Manage focus when the menu opens
    useEffect(() => {
        if (open && anchorEl) {
            anchorEl.focus();
        }
    }, [open, anchorEl]);

    /**
     * close modal before submitting change
     * @param onChange
     */
    const handleChange = (onChange: (values: FilterValues) => void) => (values: FilterValues) => {
        setAnchorEl(null);
        onChange(values);
    };

    return (
        <>
            <Tooltip title={translate("Search in fields")}>
                <StyledIconButton
                    onClick={(event: MouseEvent<HTMLElement>) => {
                        sendButtonAnalytics("Search in field - Open", ButtonClickAnalyticsType.OPEN);
                        setAnchorEl(event.currentTarget);
                    }}
                    id={"search-in-fields-button"}
                    aria-controls={open ? "search-in-fields-menu" : undefined}
                    aria-haspopup={true}
                    aria-expanded={open}
                    className="kms-ds-search-in-fields-button"
                >
                    <Settings24Icon />
                </StyledIconButton>
            </Tooltip>
            <StyledMenu
                open={open}
                classes={{ paper: "kms-ds-global-search-search-in-fields-menu" }}
                onClose={() => setAnchorEl(null)}
                id={"search-in-fields-menu"}
                aria-labelledby={"search-in-fields-button"}
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
            >
                <FieldsSelector {...props} onChange={handleChange(props.onChange)} />
            </StyledMenu>
        </>
    );
}
export default FilterMenu;
